export const formInitials = {
  current: null,
  isLoading: false,
  settings: { native: { currency: "USD", priceFormat: "100$" } },
  error: null,
  validations: {
    IS_REQUIRED: "This field must not be empty.",
    LETTERS: "Must contain letter.",
    DIGITS: "Must contain number.",
    MIN_MAX_QUANTITY: "Please enter a value between {min} and {max}.",
    MIN_MAX_SIZE: "Please upload a file between {min} and {max} {sizeType}.",
    FILE_TYPE_FORMAT: "Please upload a file of these {types / formats}.",
    EMAIL: "Please enter a valid Email address.",
    URL: "Please enter a valid URL.",
    REGEX: "Write your regex error message.",
    DOMAIN: "Please enter a valid domain.",
    MIN_MAX_DATE: "Please enter a valid date.",
    MIN_MAX_STRING_LENGTH:
      "Please enter at least {min} characters and no more than {max} characters.",
    MIN_MAX_OPTIONS:
      "Please select at least {min} options and no more than {max} options",
  },
  fonts: [
    {
      family: "Montserrat",
      variants: ["300", "regular", "500", "600", "700"],
      subsets: ["cyrillic", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
      version: "v25",
      files: {
          "300": "http://fonts.gstatic.com/s/montserrat/v25/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpSv69pGImV6jasN9-8w.ttf",
          regular:
              "http://fonts.gstatic.com/s/montserrat/v25/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpSv69pHjnV6jasN9-8w.ttf",
          "500": "http://fonts.gstatic.com/s/montserrat/v25/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpSv69pF1mV6jasN9-8w.ttf",
          "600": "http://fonts.gstatic.com/s/montserrat/v25/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpSv69pD-mF6jasN9-8w.ttf",
          "700": "http://fonts.gstatic.com/s/montserrat/v25/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpSv69pCzml6jasN9-8w.ttf",
      },
      category: "sans-serif",
      kind: "webfonts#webfont",
    },
    {
      family: "Quicksand",
      variants: ["300", "regular", "500", "600", "700"],
      subsets: ["latin", "latin-ext", "vietnamese"],
      version: "v30",
      files: {
        300: "http://fonts.gstatic.com/s/quicksand/v30/6xK-dSZaM9iE8KbpRA_LJ3z8mH9BOJvgkKEo18G0wx40QDw.ttf",
        500: "http://fonts.gstatic.com/s/quicksand/v30/6xK-dSZaM9iE8KbpRA_LJ3z8mH9BOJvgkM0o18G0wx40QDw.ttf",
        600: "http://fonts.gstatic.com/s/quicksand/v30/6xK-dSZaM9iE8KbpRA_LJ3z8mH9BOJvgkCEv18G0wx40QDw.ttf",
        700: "http://fonts.gstatic.com/s/quicksand/v30/6xK-dSZaM9iE8KbpRA_LJ3z8mH9BOJvgkBgv18G0wx40QDw.ttf",
        regular:
          "http://fonts.gstatic.com/s/quicksand/v30/6xK-dSZaM9iE8KbpRA_LJ3z8mH9BOJvgkP8o18G0wx40QDw.ttf",
      },
      category: "sans-serif",
      kind: "webfonts#webfont",
    },
    {
      family: "ABeeZee",
      variants: ["regular", "italic"],
      subsets: ["latin", "latin-ext"],
      version: "v22",
      files: {
        regular:
          "http://fonts.gstatic.com/s/abeezee/v22/esDR31xSG-6AGleN6tKukbcHCpE.ttf",
        italic:
          "http://fonts.gstatic.com/s/abeezee/v22/esDT31xSG-6AGleN2tCklZUCGpG-GQ.ttf",
      },
      category: "sans-serif",
      kind: "webfonts#webfont",
    },
    {
      family: "Abhaya Libre",
      variants: ["regular", "500", "600", "700", "800"],
      subsets: ["latin", "latin-ext", "sinhala"],
      version: "v13",
      files: {
        500: "http://fonts.gstatic.com/s/abhayalibre/v13/e3t5euGtX-Co5MNzeAOqinEYj2ryqtxI6oYtBA.ttf",
        600: "http://fonts.gstatic.com/s/abhayalibre/v13/e3t5euGtX-Co5MNzeAOqinEYo23yqtxI6oYtBA.ttf",
        700: "http://fonts.gstatic.com/s/abhayalibre/v13/e3t5euGtX-Co5MNzeAOqinEYx2zyqtxI6oYtBA.ttf",
        800: "http://fonts.gstatic.com/s/abhayalibre/v13/e3t5euGtX-Co5MNzeAOqinEY22_yqtxI6oYtBA.ttf",
        regular:
          "http://fonts.gstatic.com/s/abhayalibre/v13/e3tmeuGtX-Co5MNzeAOqinEge0PWovdU4w.ttf",
      },
      category: "serif",
      kind: "webfonts#webfont",
    },
    {
      family: "Bungee",
      variants: ["regular"],
      subsets: ["latin", "latin-ext", "vietnamese"],
      version: "v11",
      files: {
        regular:
          "http://fonts.gstatic.com/s/bungee/v11/N0bU2SZBIuF2PU_ECn50Kd_PmA.ttf",
      },
      category: "display",
      kind: "webfonts#webfont",
    },
    {
      family: "Abel",
      variants: ["regular"],
      subsets: ["latin"],
      version: "v18",
      files: {
        regular:
          "http://fonts.gstatic.com/s/abel/v18/MwQ5bhbm2POE6VhLPJp6qGI.ttf",
      },
      category: "sans-serif",
      kind: "webfonts#webfont",
    },
  ],
  styles: {
    background: {
      color: {
        type: 0,
        style: "#f8f8f8",
        value: {
          alpha: 1,
          blue: 248,
          green: 248,
          hue: 0,
          red: 248,
          saturation: 0,
          value: 97,
        },
      },
    },

    page: {
      widthMeasurement: "Percent",
      alignment: "left",
      border: {
        radius: 16,
        size: 0,
        color: {
          isStyleVisible: true,
          solid: "#434e5a33",
          gradient: null,
          imageUrl: null,
          lastModified: {
            style: "#434e5a33",
            type: 0,
            value: {
              alpha: 0.2,
              blue: 90,
              green: 78,
              hue: 211,
              red: 67,
              saturation: 26,
              value: 35,
            },
          },
        },
      },
      fill: {
        color: {
          isStyleVisible: true,
          solid: "#fff",
          gradient: null,
          imageUrl: null,
          lastModified: {
            style: "#fff",
            type: 0,
            value: {
              alpha: 1,
              blue: 255,
              green: 255,
              hue: 0,
              red: 255,
              saturation: 0,
              value: 100,
            },
          },
        },
      },
    },
    buttons: {
      submit: {
        input: {
          data: {
            contentType: "placeholder",
            defaultText: "Submit",
            placeholder: "Submit",
          },
          styles: {
            input: {
              widthPx: null,
              widthPercent: 100,
              height: 44,
              widthMeasurement: "Px",
              fill: {
                color: {
                  isStyleVisible: true,
                  solid: "#33bfa1",
                  gradient: null,
                  imageUrl: null,
                  lastModified: {
                    style: "#33bfa1",
                    type: 0,
                    value: {
                      alpha: 1,
                      blue: 90,
                      green: 78,
                      hue: 211,
                      red: 67,
                      saturation: 26,
                      value: 35,
                    },
                  },
                },
              },
              border: {
                radius: 8,
                size: 1,
                color: {
                  isStyleVisible: true,
                  solid: "#434e5a33",
                  gradient: null,
                  imageUrl: null,
                  lastModified: {
                    style: "#33bfa1",
                    type: 0,
                    value: {
                      alpha: 1,
                      green: 79,
                      hue: 211,
                      red: 58,
                      saturation: 26,
                      value: 31,
                    },
                  },
                },
              },
            },
            inputValue: {
              family: "Quicksand",
              weight: 500,
              size: "16",
              isItalic: false,
              isUnderline: false,
              isStrikethrough: false,
              alignment: "center",
              color: {
                isStyleVisible: true,
                solid: "#FFFFFF",
                gradient: null,
                imageUrl: null,
                lastModified: {
                  style: "#FFFFFF",
                  type: 0,
                  value: {
                    alpha: 1,
                    blue: 90,
                    green: 78,
                    hue: 211,
                    red: 67,
                    saturation: 26,
                    value: 35,
                  },
                },
              },
            },
          },
        },
      },
      back: {
        input: {
          data: {
            contentType: "placeholder",
            defaultText: "Back",
            placeholder: "Back",
          },
          styles: {
            input: {
              widthPx: null,
              widthPercent: 100,
              height: 44,
              widthMeasurement: "Px",
              fill: {
                color: {
                  isStyleVisible: true,
                  solid: "#fff",
                  gradient: null,
                  imageUrl: null,
                  lastModified: {
                    style: "#fff",
                    type: 0,
                    value: {
                      alpha: 1,
                      blue: 255,
                      green: 255,
                      hue: 0,
                      red: 255,
                      saturation: 0,
                      value: 100,
                    },
                  },
                },
              },
              border: {
                radius: 8,
                size: 1,
                color: {
                  isStyleVisible: true,
                  solid: "#33bfa1",
                  gradient: null,
                  imageUrl: null,
                  lastModified: {
                    style: "#33bfa1",
                    type: 0,
                    value: {
                      alpha: 1,
                      blue: 90,
                      green: 78,
                      hue: 211,
                      red: 67,
                      saturation: 26,
                      value: 35,
                    },
                  },
                },
              },
            },
            inputValue: {
              family: "Quicksand",
              weight: 500,
              size: "16",
              isItalic: false,
              isUnderline: false,
              isStrikethrough: false,
              alignment: "center",
              color: {
                isStyleVisible: true,
                solid: "#33bfa1",
                gradient: null,
                imageUrl: null,
                lastModified: {
                  style: "#33bfa1",
                  type: 0,
                  value: {
                    alpha: 1,
                    blue: 90,
                    green: 78,
                    hue: 211,
                    red: 67,
                    saturation: 26,
                    value: 35,
                  },
                },
              },
            },
          },
        },
        icon: {
          styles: {
            input: {
              widthPx: null,
              widthPercent: 100,
              height: 44,
              widthMeasurement: "Percent",
              fill: {
                color: {
                  isStyleVisible: true,
                  solid: "#434E5A",
                  gradient: null,
                  imageUrl: null,
                  lastModified: {
                    style: "#434E5A",
                    type: 0,
                    value: {
                      alpha: 1,
                      blue: 255,
                      green: 255,
                      hue: 0,
                      red: 255,
                      saturation: 0,
                      value: 100,
                    },
                  },
                },
              },
              border: {
                radius: 50,
                size: "0",
                color: {
                  isStyleVisible: true,
                  solid: "#33bfa1",
                  gradient: null,
                  imageUrl: null,
                  lastModified: {
                    style: "#33bfa1",
                    type: 0,
                    value: {
                      alpha: 1,
                      blue: 90,
                      green: 78,
                      hue: 211,
                      red: 67,
                      saturation: 26,
                      value: 35,
                    },
                  },
                },
              },
              hoverColor: {
                isStyleVisible: true,
                solid: "#33bfa1",
                gradient: null,
                imageUrl: null,
                lastModified: {
                  style: "#33bfa1",
                  type: 0,
                  value: {
                    alpha: 1,
                    blue: 90,
                    green: 78,
                    hue: 211,
                    red: 67,
                    saturation: 26,
                    value: 35,
                  },
                },
              },
            },
            inputValue: {
              family: "Quicksand",
              weight: "400",
              size: "24",
              isItalic: false,
              isUnderline: false,
              isStrikethrough: false,
              alignment: "left",
              color: {
                isStyleVisible: true,
                solid: "#434E5A",
                gradient: null,
                imageUrl: null,
                lastModified: {
                  style: "#434E5A",
                  type: 0,
                  value: {
                    alpha: 1,
                    blue: 90,
                    green: 78,
                    hue: 0,
                    red: 67,
                    saturation: 0,
                    value: 97,
                  },
                },
              },
            },
          },
        },
      },
      next: {
        input: {
          data: {
            contentType: "placeholder",
            defaultText: "Next",
            placeholder: "Next",
          },
          styles: {
            input: {
              widthPx: null,
              widthPercent: 100,
              height: 44,
              widthMeasurement: "Px",
              fill: {
                color: {
                  isStyleVisible: true,
                  solid: "#33bfa1",
                  gradient: null,
                  imageUrl: null,
                  lastModified: {
                    style: "#33bfa1",
                    type: 0,
                    value: {
                      alpha: 1,
                      blue: 90,
                      green: 78,
                      hue: 211,
                      red: 67,
                      saturation: 26,
                      value: 35,
                    },
                  },
                },
              },
              border: {
                radius: 8,
                size: 1,
                color: {
                  isStyleVisible: true,
                  solid: "#434e5a33",
                  gradient: null,
                  imageUrl: null,
                  lastModified: {
                    style: "#33bfa1",
                    type: 0,
                    value: {
                      alpha: 1,
                      green: 79,
                      hue: 211,
                      red: 58,
                      saturation: 26,
                      value: 31,
                    },
                  },
                },
              },
            },
            inputValue: {
              family: "Quicksand",
              weight: 500,
              size: "16",
              isItalic: false,
              isUnderline: false,
              isStrikethrough: false,
              alignment: "center",
              color: {
                isStyleVisible: true,
                solid: "#FFFFFF",
                gradient: null,
                imageUrl: null,
                lastModified: {
                  style: "#FFFFFF",
                  type: 0,
                  value: {
                    alpha: 1,
                    blue: 90,
                    green: 78,
                    hue: 211,
                    red: 67,
                    saturation: 26,
                    value: 35,
                  },
                },
              },
            },
          },
        },
        icon: {
          styles: {
            input: {
              widthPx: null,
              widthPercent: 100,
              height: 44,
              widthMeasurement: "Percent",
              fill: {
                color: {
                  isStyleVisible: true,
                  solid: "#434E5A",
                  gradient: null,
                  imageUrl: null,
                  lastModified: {
                    style: "#434E5A",
                    type: 0,
                    value: {
                      alpha: 1,
                      blue: 255,
                      green: 255,
                      hue: 0,
                      red: 255,
                      saturation: 0,
                      value: 100,
                    },
                  },
                },
              },
              border: {
                radius: 50,
                size: "0",
                color: {
                  isStyleVisible: true,
                  solid: "#33bfa1",
                  gradient: null,
                  imageUrl: null,
                  lastModified: {
                    style: "#33bfa1",
                    type: 0,
                    value: {
                      alpha: 1,
                      blue: 90,
                      green: 78,
                      hue: 211,
                      red: 67,
                      saturation: 26,
                      value: 35,
                    },
                  },
                },
              },
              hoverColor: {
                isStyleVisible: true,
                solid: "#33bfa1",
                gradient: null,
                imageUrl: null,
                lastModified: {
                  style: "#33bfa1",
                  type: 0,
                  value: {
                    alpha: 1,
                    blue: 90,
                    green: 78,
                    hue: 211,
                    red: 67,
                    saturation: 26,
                    value: 35,
                  },
                },
              },
            },
            inputValue: {
              family: "Quicksand",
              weight: "400",
              size: "24",
              isItalic: false,
              isUnderline: false,
              isStrikethrough: false,
              alignment: "left",
              color: {
                isStyleVisible: true,
                solid: "#434E5A",
                gradient: null,
                imageUrl: null,
                lastModified: {
                  style: "#434E5A",
                  type: 0,
                  value: {
                    alpha: 1,
                    blue: 90,
                    green: 78,
                    hue: 0,
                    red: 67,
                    saturation: 0,
                    value: 97,
                  },
                },
              },
            },
          },
        },
      },
      edit: {
        input: {
          data: {
            contentType: "placeholder",
            defaultText: "Edit Answer",
            placeholder: "Edit Answer",
          },
          styles: {
            input: {
              widthPx: 136,
              widthPercent: null,
              height: 44,
              widthMeasurement: "Px",
              fill: {
                color: {
                  isStyleVisible: true,
                  solid: "#33bfa1",
                  gradient: null,
                  imageUrl: null,
                  lastModified: {
                    style: "#33bfa1",
                    type: 0,
                    value: {
                      alpha: 1,
                      blue: 90,
                      green: 78,
                      hue: 211,
                      red: 67,
                      saturation: 26,
                      value: 35,
                    },
                  },
                },
              },
              border: {
                radius: 8,
                size: 1,
                color: {
                  isStyleVisible: true,
                  solid: "#434e5a33",
                  gradient: null,
                  imageUrl: null,
                  lastModified: {
                    style: "#33bfa1",
                    type: 0,
                    value: {
                      alpha: 1,
                      green: 79,
                      hue: 211,
                      red: 58,
                      saturation: 26,
                      value: 31,
                    },
                  },
                },
              },
            },
            inputValue: {
              family: "Quicksand",
              weight: 500,
              size: "16",
              isItalic: false,
              isUnderline: false,
              isStrikethrough: false,
              alignment: "center",
              color: {
                isStyleVisible: true,
                solid: "#FFFFFF",
                gradient: null,
                imageUrl: null,
                lastModified: {
                  style: "#FFFFFF",
                  type: 0,
                  value: {
                    alpha: 1,
                    blue: 90,
                    green: 78,
                    hue: 211,
                    red: 67,
                    saturation: 26,
                    value: 35,
                  },
                },
              },
            },
          },
        },
        icon: {
          styles: {
            input: {
              widthPx: null,
              widthPercent: 100,
              height: 44,
              widthMeasurement: "Percent",
              fill: {
                color: {
                  isStyleVisible: true,
                  solid: "#434E5A",
                  gradient: null,
                  imageUrl: null,
                  lastModified: {
                    style: "#434E5A",
                    type: 0,
                    value: {
                      alpha: 1,
                      blue: 255,
                      green: 255,
                      hue: 0,
                      red: 255,
                      saturation: 0,
                      value: 100,
                    },
                  },
                },
              },
              border: {
                radius: 50,
                size: "0",
                color: {
                  isStyleVisible: true,
                  solid: "#33bfa1",
                  gradient: null,
                  imageUrl: null,
                  lastModified: {
                    style: "#33bfa1",
                    type: 0,
                    value: {
                      alpha: 1,
                      blue: 90,
                      green: 78,
                      hue: 211,
                      red: 67,
                      saturation: 26,
                      value: 35,
                    },
                  },
                },
              },
              hoverColor: {
                isStyleVisible: true,
                solid: "#33bfa1",
                gradient: null,
                imageUrl: null,
                lastModified: {
                  style: "#33bfa1",
                  type: 0,
                  value: {
                    alpha: 1,
                    blue: 90,
                    green: 78,
                    hue: 211,
                    red: 67,
                    saturation: 26,
                    value: 35,
                  },
                },
              },
            },
            inputValue: {
              family: "Quicksand",
              weight: "400",
              size: "24",
              isItalic: false,
              isUnderline: false,
              isStrikethrough: false,
              alignment: "left",
              color: {
                isStyleVisible: true,
                solid: "#434E5A",
                gradient: null,
                imageUrl: null,
                lastModified: {
                  style: "#434E5A",
                  type: 0,
                  value: {
                    alpha: 1,
                    blue: 90,
                    green: 78,
                    hue: 0,
                    red: 67,
                    saturation: 0,
                    value: 97,
                  },
                },
              },
            },
          },
        },
      },
      fill: {
        input: {
          data: {
            contentType: "placeholder",
            defaultText: "Fill Again",
            placeholder: "Fill Again",
          },
          styles: {
            input: {
              widthPx: 136,
              widthPercent: null,
              height: 44,
              widthMeasurement: "Px",
              fill: {
                color: {
                  isStyleVisible: true,
                  solid: "#fff",
                  gradient: null,
                  imageUrl: null,
                  lastModified: {
                    style: "#fff",
                    type: 0,
                    value: {
                      alpha: 1,
                      blue: 255,
                      green: 255,
                      hue: 0,
                      red: 255,
                      saturation: 0,
                      value: 100,
                    },
                  },
                },
              },
              border: {
                radius: 8,
                size: 1,
                color: {
                  isStyleVisible: true,
                  solid: "#33bfa1",
                  gradient: null,
                  imageUrl: null,
                  lastModified: {
                    style: "#33bfa1",
                    type: 0,
                    value: {
                      alpha: 1,
                      blue: 90,
                      green: 78,
                      hue: 211,
                      red: 67,
                      saturation: 26,
                      value: 35,
                    },
                  },
                },
              },
            },
            inputValue: {
              family: "Quicksand",
              weight: 500,
              size: "16",
              isItalic: false,
              isUnderline: false,
              isStrikethrough: false,
              alignment: "center",
              color: {
                isStyleVisible: true,
                solid: "#33bfa1",
                gradient: null,
                imageUrl: null,
                lastModified: {
                  style: "#33bfa1",
                  type: 0,
                  value: {
                    alpha: 1,
                    blue: 90,
                    green: 78,
                    hue: 211,
                    red: 67,
                    saturation: 26,
                    value: 35,
                  },
                },
              },
            },
          },
        },
        icon: {
          styles: {
            input: {
              widthPx: null,
              widthPercent: 100,
              height: 44,
              widthMeasurement: "Percent",
              fill: {
                color: {
                  isStyleVisible: true,
                  solid: "#434E5A",
                  gradient: null,
                  imageUrl: null,
                  lastModified: {
                    style: "#434E5A",
                    type: 0,
                    value: {
                      alpha: 1,
                      blue: 255,
                      green: 255,
                      hue: 0,
                      red: 255,
                      saturation: 0,
                      value: 100,
                    },
                  },
                },
              },
              border: {
                radius: 50,
                size: "0",
                color: {
                  isStyleVisible: true,
                  solid: "#33bfa1",
                  gradient: null,
                  imageUrl: null,
                  lastModified: {
                    style: "#33bfa1",
                    type: 0,
                    value: {
                      alpha: 1,
                      blue: 90,
                      green: 78,
                      hue: 211,
                      red: 67,
                      saturation: 26,
                      value: 35,
                    },
                  },
                },
              },
              hoverColor: {
                isStyleVisible: true,
                solid: "#33bfa1",
                gradient: null,
                imageUrl: null,
                lastModified: {
                  style: "#33bfa1",
                  type: 0,
                  value: {
                    alpha: 1,
                    blue: 90,
                    green: 78,
                    hue: 211,
                    red: 67,
                    saturation: 26,
                    value: 35,
                  },
                },
              },
            },
            inputValue: {
              family: "Quicksand",
              weight: "400",
              size: "24",
              isItalic: false,
              isUnderline: false,
              isStrikethrough: false,
              alignment: "left",
              color: {
                isStyleVisible: true,
                solid: "#434E5A",
                gradient: null,
                imageUrl: null,
                lastModified: {
                  style: "#434E5A",
                  type: 0,
                  value: {
                    alpha: 1,
                    blue: 90,
                    green: 78,
                    hue: 0,
                    red: 67,
                    saturation: 0,
                    value: 97,
                  },
                },
              },
            },
          },
        },
      },
      download: {
        input: {
          data: {
            contentType: "placeholder",
            defaultText: "Download",
            placeholder: "Download",
          },
          styles: {
            input: {
              widthPx: 136,
              widthPercent: null,
              height: 44,
              widthMeasurement: "Px",
              fill: {
                color: {
                  isStyleVisible: true,
                  solid: "#fff",
                  gradient: null,
                  imageUrl: null,
                  lastModified: {
                    style: "#fff",
                    type: 0,
                    value: {
                      alpha: 1,
                      blue: 255,
                      green: 255,
                      hue: 0,
                      red: 255,
                      saturation: 0,
                      value: 100,
                    },
                  },
                },
              },
              border: {
                radius: 8,
                size: 0,
                color: {
                  isStyleVisible: true,
                  solid: "#33bfa1",
                  gradient: null,
                  imageUrl: null,
                  lastModified: {
                    style: "#33bfa1",
                    type: 0,
                    value: {
                      alpha: 1,
                      blue: 90,
                      green: 78,
                      hue: 211,
                      red: 67,
                      saturation: 26,
                      value: 35,
                    },
                  },
                },
              },
            },
            inputValue: {
              family: "Quicksand",
              weight: 500,
              size: "16",
              isItalic: false,
              isUnderline: false,
              isStrikethrough: false,
              alignment: "center",
              color: {
                isStyleVisible: true,
                solid: "#33bfa1",
                gradient: null,
                imageUrl: null,
                lastModified: {
                  style: "#33bfa1",
                  type: 0,
                  value: {
                    alpha: 1,
                    blue: 90,
                    green: 78,
                    hue: 211,
                    red: 67,
                    saturation: 26,
                    value: 35,
                  },
                },
              },
            },
          },
        },
        icon: {
          styles: {
            input: {
              widthPx: null,
              widthPercent: 100,
              height: 44,
              widthMeasurement: "Percent",
              fill: {
                color: {
                  isStyleVisible: true,
                  solid: "#434E5A",
                  gradient: null,
                  imageUrl: null,
                  lastModified: {
                    style: "#434E5A",
                    type: 0,
                    value: {
                      alpha: 1,
                      blue: 255,
                      green: 255,
                      hue: 0,
                      red: 255,
                      saturation: 0,
                      value: 100,
                    },
                  },
                },
              },
              border: {
                radius: 0,
                size: "0",
                color: {
                  isStyleVisible: true,
                  solid: "#33bfa1",
                  gradient: null,
                  imageUrl: null,
                  lastModified: {
                    style: "#33bfa1",
                    type: 0,
                    value: {
                      alpha: 1,
                      blue: 90,
                      green: 78,
                      hue: 211,
                      red: 67,
                      saturation: 26,
                      value: 35,
                    },
                  },
                },
              },
              hoverColor: {
                isStyleVisible: true,
                solid: "#33bfa1",
                gradient: null,
                imageUrl: null,
                lastModified: {
                  style: "#33bfa1",
                  type: 0,
                  value: {
                    alpha: 1,
                    blue: 90,
                    green: 78,
                    hue: 211,
                    red: 67,
                    saturation: 26,
                    value: 35,
                  },
                },
              },
            },
            inputValue: {
              family: "Quicksand",
              weight: "400",
              size: "24",
              isItalic: false,
              isUnderline: false,
              isStrikethrough: false,
              alignment: "left",
              color: {
                isStyleVisible: true,
                solid: "#434E5A",
                gradient: null,
                imageUrl: null,
                lastModified: {
                  style: "#434E5A",
                  type: 0,
                  value: {
                    alpha: 1,
                    blue: 90,
                    green: 78,
                    hue: 0,
                    red: 67,
                    saturation: 0,
                    value: 97,
                  },
                },
              },
            },
          },
        },
      },
    },
  },
};
